<template>
  <div>
  
  
 <h4 v-if="createForm" slot="header" class="card-title">
    Add New Shareholder Company To Database
    </h4>
     <h4 v-else slot="header" class="card-title">
     Update Shareholder Company
    </h4>

        
<card style="text-align:right;">

	
	
	<!-- start company form -->
	<div  style="">
	
	 <div class="row" style="">
      <label class="col-sm-2 col-form-label">Company Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="company_name"
                  v-model="model.company_name"
                   v-validate="modelValidations.company_name"
                  :error="getError('company_name')"
                  >
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    

    <div class="row" style="">
      <label class="col-sm-2 col-form-label">Company Registration Number</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="company_reg_num"
                  v-model="model.company_reg_num"
                  v-validate="modelValidations.company_reg_num"
                  :error="getError('company_reg_num')"
                  
                  >
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
     <div class="row" style="">
      <label class="col-sm-2 col-form-label">Country Of Incorporation</label>
      <div class="col-sm-7">

          <fg-input>
                  
                  
                    <el-select class="select-primary"
                             size="large"
                             placeholder="Select Country"
                             v-model="model.country">
                    <el-option v-for="option in variables.countries"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
    <div class="row" style="">
      <label class="col-sm-2 col-form-label">Company Address</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="address"
                  v-model="model.address">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
	

	</div>
	<!-- end company form -->
	
	
</card>

 <div>
      <h4 v-if="createForm" class="title">Add Representative</h4>
      <h4 v-else class="title">Change Representative</h4>
   </div> 
         
   <card>     
      <div>Search Using Govt ID Number</div>
				   <fg-input type="text"
                  		name="search_person_id_num"
                 	    v-model="search_person_id_num"
                 	    style="max-width:500px"
                 	    >
        			</fg-input>


			   <p-button  outline type="default" @click.prevent="searchPerson()">Search People</p-button>
		<div v-if="rep_person_found" style="margin-top:50px;margin-bottom:50px;">
		 
		  <h5 >Company Representative</h5>
		<strong> Name: </strong>  {{rep.first_name}} {{rep.last_name}} 
		 <br/>
		<strong> ID Number: </strong>  {{rep.gov_id}}
		 <br/>
		<strong> Contact Number: </strong> {{rep.contact_num}}
		  <br/>
		<strong> Email: </strong> {{rep.email}}
		
		</div>	         
    </card>    
    
    


 <div slot="footer" class="text-center">
      <p-button v-if="createForm"  type="info" @click.prevent="submitNewShareholderCompanyForm">Submit New Shareholder Company</p-button>
      <p-button v-else  type="info" @click.prevent="editShareholderCompany">Edit Shareholder Company</p-button>
    </div>
   


  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     	let uri = this.$base_url+'/api/v1/common/get/common/person';
   
			 ApiService.get(uri).then(response => {
				
				this.variables = response.data.variables;

		})
		
     
       if(this.$route.params.shcid!=0){
     		this.createForm = false;
     		
     		let uri = this.$base_url+'/api/v1/entities/get/shareholder_company/'+ this.$route.params.shcid;
   
			 ApiService.get(uri).then(response => {
				
				this.model = response.data.company;
				if(response.data.rep){
					this.rep = response.data.rep;
					this.model.rep_id = response.data.rep.id;
					this.rep_person_found = true;
				}
			    
			
			})

     	}
     	

            	
      
    },
    
     
    data () {
      return {
        coy:[],
    	eid: this.$route.params.eid,
    	oid: this.$route.params.oid,
    	createForm: true,
    	displayCompanyForm: false,
    	search_person_id_num: '',
    	rep_person_found: false,
    	variables:[],
        model: {
          
          company_name:'',
          company_reg_num:'',
          country:'SG',
          company_address:'',
          effective_date:'',
          rep_id:'',

        },
        rep:[],
        modelValidations: {
          company_reg_num: {
            required: true
          },
          company_name: {
            required: true,
          },
          address_1: {
            required: true,
          },
          status: {
          	required: true,
          },
          is_contact_person: {
            required: true,
          },
          effective_date: {
            required: true,
          },
           position: {
            required: true,
          },
          nationality: {
            required: true,
          },
          gov_id: {
            required: true,
          },
          email: {
            required: true,
            email: true
          },
          contact_num: {
            required: true,
          },
          
        },
        
        selects: {
          gov_id_type: [
            {value: 1, label: 'Government ID'},
            {value: 2, label: 'Passport'},
		   ],
		  is_company:[
            {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   ] 
        },
      }
    },
    methods:{
    	searchPerson(){
       		let search_term = "NONE";

			search_term = this.search_person_id_num
       		let uri = this.$base_url+'/api/v1/shareholders/search/'+search_term;

       		const vm = this;
      		ApiService.post(uri).then(response => {
      				if(response.data.exist == 1){

							this.rep = response.data.person;
      						this.model.rep_id = response.data.person.id;
      						this.rep_person_found = true;
      				}
      				else{
      					swal({
						  title: 'Not Found',
						  text: 'Person not found. Please add this person to the database first.',
						  type: 'warning',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){


						})


      				}

     		 })

    	},//end search person
       displayErrorMessage(msg){
        		swal({
					  title: 'Error!',
					  text: msg,
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 	})
        
        
        
        },
    	onIsCompanyRepChange(event){
       		if(this.model.is_company == 1){

       			this.displayCompanyForm = true;
       		}
       		else{
       			this.displayCompanyForm = false;
       		}
       
       },
 
       getError(fieldName) {
        return this.errors.first(fieldName)
      },
      submitNewShareholderCompanyForm() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/entities/create_shareholder_company';
      		ApiService.post(uri, this.model).then(response => {
      				if(!response.data.company){
      					this.displayErrorMessage(response.data.message);
      				}
      				else{
         				this.$router.push( '/people')
         			}
         		
     		 })
  		  }
        
         
        })
      },///end validate+create
      editShareholderCompany() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/entities/edit_shareholder_company/'+this.$route.params.shcid;
      		ApiService.post(uri, this.model).then(response => {
      	
         			if(!response.data.company){
      					this.displayErrorMessage(response.data.message);
      				}
      				else{
         				this.$router.push( '/people')
         			}
         		
     		 })
  		  }
        
         
        })
      },///end validate+edit
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


